module.exports = __webpack_public_path__ + "img/seigaiha_three.22bbb8f9.svg";